enum MarketPenetrationTypeEnum {
  MarketOnly = "universeProvider",
  Overlap = "networkMarketOverlap",
  InNetworkOnly = "inNetworkOnly",
}

export { MarketPenetrationTypeEnum };
